import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta02Model } from './model-consultaSeguimentoPergunta02'

export function isPergunta02IgnoraAllNao(value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_IGNORA']): boolean {
  return value?.IGNORA_PESSOAS === SimNaoEnum.NAO && value?.IGNORA_SONS === SimNaoEnum.NAO
}

export function hasPergunta02IgnoraAnySim(value: ConsultaSeguimentoPergunta02Model['PERGUNTA_02_IGNORA']): boolean {
  return value?.IGNORA_PESSOAS === SimNaoEnum.SIM || value?.IGNORA_SONS === SimNaoEnum.SIM
}
